import React, { useEffect, useState } from 'react'
import Handler from '../../Helpers/Handler';
import { Button, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Pagination from '../../Helpers/Pagination';
import "boxicons/css/boxicons.min.css";
import { toast } from 'react-toastify';

const List = () => {

    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const navigate = useNavigate();

    const maxPage = Math.ceil(total / limit);

    const getProducts = async () => {
        const response = await Handler({
            method: "get",
            url: `/products/list.php?search=${search}&page=${page}&limit=${limit}`
        });

        if (response?.success) {
            setData(response?.data);
            setTotal(response?.total);
            setPage(response?.page);
        } else {
            toast.error(response?.message);
        }
    };

    useEffect(() => {
        getProducts();
    }, [page]);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            setPage(1);
            getProducts();
        }, 400);

        return () => clearTimeout(delayDebounce);
    }, [search]);


    /* -------------------- TOGGLE STATUS -------------------- */
    const toggleStatus = async (id, currentStatus) => {

        const newStatus = currentStatus === 1 ? 0 : 1;

        const response = await Handler({
            method: "patch",
            url: `/products/toggle.php`,
            data: {
                product_id: id,
                is_active: newStatus
            }
        });

        if (response?.success) {
            toast.success(response.message);
            getProducts();
        } else {
            toast.error(response.message || "Failed to update");
        }
    };


    return (
        <div className="dashboard-wrapper py-4">
            <style>{`
                /* Mobile-la spacing and table horizontal scroll fix */
                @media (max-width: 576px) {
                    .dashboard-header-flex {
                        flex-direction: column;
                        align-items: flex-start !important;
                        gap: 15px;
                    }
                    .header-actions {
                        width: 100%;
                        flex-direction: column;
                    }
                    .searchbox {
                        width: 100% !important;
                    }
                    .btn-add {
                        width: 100%;
                    }
                    .dash-card {
                        padding: 15px !important;
                    }
                }
                .product-img {
                    width: 50px;
                    height: 50px;
                    object-fit: cover;
                    border-radius: 5px;
                }
                .modern-table th {
                    white-space: nowrap;
                }
            `}</style>

            <div className="container">

                {/* HEADER - Responsive Flex Added */}
                <div className="d-flex justify-content-between align-items-center mb-4 dashboard-header-flex">
                    <h5 className="section-heading mb-0">
                        <i className="bx bxs-box me-2"></i> Product List
                    </h5>

                    <div className="d-flex gap-2 header-actions">
                        <Input
                            className="searchbox"
                            style={{ width: '250px' }}
                            type="text"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search Products"
                        />

                        <Button
                            className="btn-add d-flex align-items-center justify-content-center"
                            color="primary"
                            onClick={() => navigate('/products/add')}
                        >
                            <i className='bx bx-plus me-1'></i> Add Product
                        </Button>
                    </div>
                </div>

                {/* TABLE CARD */}
                <div className="dash-card p-4 mb-4 bg-white shadow-sm rounded">
                    {/* table-responsive class is key for mobile scroll */}
                    <div className="table-responsive">
                        <table className="table modern-table align-middle">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Price (₹)</th>
                                    <th>Unit</th>
                                    <th>Category</th>
                                    <th>Subcategory</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length ? (
                                    data.map((item, index) => (
                                        <tr key={item.product_id}>
                                            <td>{(page - 1) * limit + index + 1}</td>

                                            <td>
                                                {item.image ? (
                                                    <img
                                                        src={`https://demoadmin.bizcarto.in/api/${item.image}`}
                                                        alt={item?.name}
                                                        className="product-img border"
                                                    />
                                                ) : (
                                                    <span className="no-img small text-muted">No Image</span>
                                                )}
                                            </td>

                                            <td className="text-capitalize fw-bold">{item.name}</td>
                                            <td>{item.price}</td>
                                            <td className="text-capitalize">{item.unit}</td>
                                            <td>{item.category}</td>
                                            <td>{item.subcategory}</td>

                                            <td>
                                                <Button
                                                    size="sm"
                                                    color={item.is_active === 1 ? "danger" : "success"}
                                                    className="rounded-pill px-3 acti-btn"
                                                    style={{ minWidth: '100px' }}
                                                    onClick={() => toggleStatus(item.product_id, item.is_active)}
                                                >
                                                    {item.is_active === 1 ? "De-active" : "Active"}
                                                </Button>
                                            </td>

                                            <td>
                                                <Button
                                                    size="sm"
                                                    color="dark"
                                                    className="rounded-pill d-flex align-items-center"
                                                    onClick={() => navigate(`/products/${item.product_id}`)}
                                                >
                                                    <i className="bx bx-edit me-1"></i> Edit
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-5 text-muted">
                                            No Products Found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* PAGINATION */}
                    <div className="mt-4 d-flex justify-content-center">
                        <Pagination
                            page={page}
                            total={total}
                            limit={limit}
                            onPrev={() => page > 1 && setPage(page - 1)}
                            onNext={() => page < maxPage && setPage(page + 1)}
                        />
                    </div>
                </div>

            </div>
        </div>
    );
};

export default List;